<template>
  <div class="text-center">
    <v-dialog v-model="dialog" @keydown.esc="cancel" persistent width="500">
      <v-card>
        <v-card-title>Calculation Selection</v-card-title>
        <div class="px-4 pt-4">
          <v-form v-model="isFormValid" ref="form" lazy-validation>
            <div>
              <v-select
                v-model="level"
                :items="levelsList"
                :disabled="levelId === 0"
                label="Level"
                outlined
                dense
              ></v-select>
            </div>
            <div>
              <v-select
                v-model="selectionType"
                :items="selectionList"
                label="Calculation type"
                outlined
                dense
              ></v-select>
            </div>
            <div>
              <v-select
                v-model="calcItem"
                :items="calculationsList"
                item-value="ShortName"
                item-text="ShortName"
                label="Calculation item"
                :rules="this.rules"
                outlined
                dense
              ></v-select>
            </div>
          </v-form>
        </div>
        <v-card-actions>
          <v-btn color="primary" outlined @click="clear"> Clear </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="cancel"> Cancel </v-btn>
          <v-btn color="primary" depressed @click.native="ok"> Ok </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'CalculationSelection',
  props: {
    levelId: { type: Number, required: true },
    typeList: { type: Array, default: null },
    groupId: { type: Number, default: 0 },
    exitForm: { type:String},
  },

  data() {
    return {
      dialog: false,
      level: this.levelId,
      selectionType: null,
      calcItem: null,
      selectionList: [],
      calculationsList: [],
      isFormValid: false,
      rules: [(v) => !!v || 'Required.'],
    };
  },

  computed: {
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },

    levelsList() {
      var list = [
        { text: 'System', value: 0 },
        { text: 'Plan', value: this.currentPlanId },
      ];
      if (this.exitForm && this.exitForm.indexOf('Retirement')>=0) {
        list.push({ text:'Model', value:-1});
      }
      return list;
    },

    selectedItem() {
      if (this.calcItem) {
        if (this.level === null) return;
        let displayLevel;
        if (this.level === 0) {
          displayLevel = 0;
        } else {
          displayLevel = 1;
        }
        if (this.level<0) {
          return `[${this.calcItem}]`;
        }

        switch (this.selectionType) {
          case 'Inputs':
            return `[INPUT.${this.calcItem}]`;
          case 'Salary Array':
          case 'Investment':
            return `[FPS.${displayLevel}${this.calcItem}]`;
          default:
            return `[${displayLevel}${this.calcItem}]`;
        }
      } else {
        return null;
      }
    },
  },

  watch: {
    level() {
      this.resetValues();
      this.selectionList = [];
      this.calculationsList = [];
      if (this.level<0) {
        this.getCalculationSelection();
      }
      else
        this.getCalculationSelection();
    },
    selectionType() {
      this.calcItem = null;
      this.calculationsList = [];
      if (this.selectionType && this.level !== null) this.getCalculationItems();
    },
    typeList() {
      this.getCalculationSelection();
    },
  },

  mounted() {
    this.getCalculationSelection();
  },

  methods: {
    open() {
      this.dialog = true;
    },

    ok() {
      if (!this.$refs.form.validate()) return;
      this.$emit('select', this.selectedItem);
      this.resetValues();
      this.dialog = false;
    },

    cancel() {
      this.resetValues();
      this.dialog = false;
    },

    clear() {
      this.$emit('select', null);
      this.resetValues();
      this.dialog = false;
    },

    resetValues() {
      this.selectionType = null;
      this.calcItem = null;
    },

    async getCalculationSelection() {
      //if (this.typeList) return (this.selectionList = this.typeList);
      try {
        if (this.level<0) {
          
          this.selectionList=['Retirement'];
        }
        else {
          const response = await this.$api.get('/Calculation/GetCalculationSelection');

          this.selectionList = response.data;
        }
      } catch (error) {
        console.log(error.message);
      }
    },

    async getCalculationItems() {
      try {
        const response = await this.$api.get(
          `/Calculation/GetCalculationItems?planId=${this.level}&calcType=${this.selectionType}&groupId=${this.groupId}`
        );

        this.calculationsList = response.data;
      } catch (error) {
        console.log(error.message);
      }
    },
  },
};
</script>
